import {
	AUTH_REQUEST,
	AUTH_REFRESH,
	AUTH_ERROR,
	AUTH_SUCCESS,
	AUTH_LOGOUT,
} from '../actions/auth';
import { USER_REQUEST } from '../actions/user';
import apiCall from '@/utils/api';

const state = {
	token: localStorage.getItem('user-token') || '',
	status: '',
	hasLoadedOnce: false,
};

const getters = {
	isAuthenticated: state => !!state.token,
	authStatus: state => state.status,
};

const actions = {
	[AUTH_REQUEST]: ({ commit, dispatch }, user) => {
		const data = {
			grant_type: 'password',
			client_id: process.env.VUE_APP_CLIENT_ID,
			client_secret: process.env.VUE_APP_CLIENT_SECRET,
			email: user.email,
			password: user.password,
		};

		return new Promise((resolve, reject) => {
			commit(AUTH_REQUEST);
			apiCall({ url: '/oauth/token', data, method: 'POST' })
				.then(resp => {
					// Here set the header of your ajax library to the token value.
					// example with axios
					commit(AUTH_SUCCESS, resp);
					// dispatch(USER_REQUEST);
					console.log(USER_REQUEST);
					resolve(resp);
				})
				.catch(err => {
					commit(AUTH_ERROR, err);
					localStorage.removeItem('user-token');
					reject(err);
				});
		});
	},
	[AUTH_LOGOUT]: ({ commit }) => {
		return new Promise(resolve => {
			commit(AUTH_LOGOUT);
			localStorage.removeItem('user-token');
			resolve();
		});
	},
};

const mutations = {
	[AUTH_REQUEST]: state => {
		state.status = 'loading';
	},
	[AUTH_REFRESH]: state => {
		state.status = 'refreshing';
	},
	[AUTH_SUCCESS]: (state, resp) => {
		state.status = 'success';
		const data = resp.data;
		localStorage.setItem('user-token', data.access_token);
		localStorage.setItem('user-token-expiry', parseInt(data.expires_in));
		localStorage.setItem('user-token-refresh', data.refresh_token);
		localStorage.setItem(
			'user-token-created-at',
			parseInt(data.created_at)
		);
		state.token = resp.data.access_token;
		state.hasLoadedOnce = true;
	},
	[AUTH_ERROR]: state => {
		state.status = 'error';
		state.hasLoadedOnce = true;
	},
	[AUTH_LOGOUT]: state => {
		state.token = '';
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
